
import { Link } from 'react-router-dom';
import { categories } from '../../../mocks/categories';

const CategoryGrid = () => {
  return (
    <section id="categories" className="py-20 lg:py-32 relative overflow-hidden">
      {/* Warm gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-amber-50 via-orange-50 to-rose-50"></div>
      <div className="absolute inset-0 bg-[url('https://public.readdy.ai/ai/img_res/7bee84b65732fa5bd67474f64b006ebe.jpg')] bg-cover bg-center opacity-20"></div>
      
      <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
        {/* Section Header */}
        <div className="mb-16">
          <p className="text-sm text-orange-600 mb-2 font-mono whitespace-nowrap">/categories</p>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 font-inter">
            Explore Our Niches
          </h2>
        </div>

        {/* Category Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {categories.map((category, index) => {
            const isFeatured = category.featured;
            const colSpan = isFeatured ? 'md:col-span-2' : 'md:col-span-1';

            return (
              <Link
                key={category.id}
                to={`/category/${category.slug}`}
                className={`group ${colSpan} bg-white/90 backdrop-blur-sm border border-orange-100 rounded-2xl p-8 hover:shadow-2xl hover:shadow-orange-200/50 hover:-translate-y-1 transition-all duration-300 cursor-pointer ${
                  isFeatured ? 'lg:flex lg:items-center lg:gap-6' : ''
                }`}
              >
                <div className={isFeatured ? 'lg:flex-shrink-0' : ''}>
                  <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-orange-100 to-amber-100 rounded-xl mb-4 group-hover:from-orange-200 group-hover:to-amber-200 transition-colors">
                    <i className={`${category.icon} text-2xl text-orange-600`}></i>
                  </div>
                </div>

                <div className="flex-1">
                  <h3 className={`font-semibold text-gray-900 mb-3 ${isFeatured ? 'text-2xl' : 'text-xl'}`}>
                    {category.name}
                  </h3>
                  <p className={`text-gray-700 leading-relaxed ${isFeatured ? 'text-base' : 'text-sm'}`}>
                    {category.description}
                  </p>
                </div>

                <div className="mt-4 lg:mt-0 flex justify-end">
                  <div className="w-8 h-8 flex items-center justify-center text-gray-400 group-hover:text-orange-600 group-hover:translate-x-1 transition-all">
                    <i className="ri-arrow-right-line text-xl"></i>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CategoryGrid;
